import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { css } from "./Theme";

const Box = props => {
  const styles = css({
    display: "block",
    boxSizing: "border-box",
    padding: 0,
    margin: 0,
    fontFamily: "-apple-system,BlinkMacSystemFont,`Segoe UI`,Roboto,Helvetica,Arial,sans-serif,`Apple Color Emoji`,`Segoe UI Emoji`,`Segoe UI Symbol`"
  });
  return ___EmotionJSX("div", _extends({}, props, {
    css: styles
  }), props.children);
};

export default Box;